export const downloadURI = (uri: string, name: string) => {
    const link: HTMLAnchorElement = document.createElement('a');

    link.download = name;
    link.href = uri;

    link.click();
    link.remove();
};
